import { render, staticRenderFns } from "./chargeFee.vue?vue&type=template&id=5a8bd466&scoped=true"
import script from "./chargeFee.vue?vue&type=script&lang=js"
export * from "./chargeFee.vue?vue&type=script&lang=js"
import style0 from "./chargeFee.vue?vue&type=style&index=0&id=5a8bd466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8bd466",
  null
  
)

export default component.exports